import { render, staticRenderFns } from "./WelfareMallTrainTicketOrder.vue?vue&type=template&id=ed64359e&scoped=true"
import script from "./WelfareMallTrainTicketOrder.vue?vue&type=script&lang=js"
export * from "./WelfareMallTrainTicketOrder.vue?vue&type=script&lang=js"
import style0 from "./WelfareMallTrainTicketOrder.vue?vue&type=style&index=0&id=ed64359e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed64359e",
  null
  
)

export default component.exports